import React, { useEffect, useState } from 'react';
import './css/comment.scss';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { Spinner } from 'react-bootstrap';
import {
  GetComments,
  GetReplyComments,
  PostComment,
  toggleCommentFocus
} from '../../Store/actions/commonActions';
import { useDispatch } from 'react-redux';
import {
  CLICK_SUBMIT_COMMENT_BUTTON,
  CLICK_SUBMIT_REPLY,
  EVENT
} from '../../TrackerFolder/constants/ActionType';
import { trackEvent } from '../../TrackerFolder/actions';
import {
  onCommentSubmitButtonPress,
  onReplyComment
} from '../../TrackerFolder/actions/FeedActions';
import { AiFillLike, AiOutlineLike } from '../icons';
import { likePress } from '../../Store/actions/grandround.action';
import { log } from '../../common/common';
import { useTracker } from '../../TrackerFolder/TrackerComponent';
import LazyImage from '../CustomLibraries/LazyImage';
import { toast } from 'react-toastify';

var commentPaginationStart = 0;
var replyPaginationStart = 0;
var showNewComment = false;

const Comments = ({
  id,
  type,
  page,
  profileImage,
  comment_count,
  title = '',
  gtmTagVariable = ''
}) => {
  const dispatch = useDispatch();
  // console.log(profileImage);
  const [showReplyArea, setShowReplyArea] = useState(false);
  const [replySelectedIndex, setReplySelectedIndex] = useState(-1);
  const [replyFieldShow, setReplyFieldShow] = useState(false);
  const [replyFieldIndex, setreplyFieldIndex] = useState(-1);
  const [loader, setLoader] = useState(true);
  const [viewMoreReplybtn, setViewMoreReplyBtn] = useState(true);
  const [mainComment, setMainComment] = useState('');
  const [replyInput, setReplyInput] = useState('');
  const [disabled, setDisabled] = useState(false);
  const [render, setRender] = useState(false);
  const [showCommentArea, setShowCommentArea] = useState(true);
  const { trackActivityEvent } = useTracker();
  // Comments & Reply Comments States
  const [comments, setComments] = useState([]);
  // console.log(comments);
  const [ReplyComments, setReplyComments] = useState([]);
  const refresh = () => setRender(!render);
  const getComments = () => {
    dispatch(
      GetComments(id, type, commentPaginationStart, 3, (res) => {
        if (res != 'error') {
          // console.log(res.data);

          if (commentPaginationStart == 0) {
            setShowCommentArea(true);
          }

          if (res.data[0] == null) {
            setShowCommentArea(false);
            setLoader(false);
          }

          if (showNewComment) {
            setComments(res.data);
          } else {
            setComments((prevArray) => {
              return [...prevArray, ...res.data];
            });
          }

          showNewComment = false;
          setLoader(false);
        }
      })
    );
  };

  useEffect(() => {
    return () => {
      commentPaginationStart = 0;
      replyPaginationStart = 0;
    };
  }, []);

  useEffect(() => {
    showNewComment = true;
    getComments();
  }, [id]);
  const submitComment = (type_id, type) => {
    setShowReplyArea(!showReplyArea);
    setReplyFieldShow(false);

    if (mainComment != '') {
      trackActivityEvent(
        CLICK_SUBMIT_COMMENT_BUTTON,
        onCommentSubmitButtonPress(page, mainComment)
      );
      let parser = {
        type_id: type_id,
        type: type,
        parent_id: 0,
        comment: mainComment
      };
      // showCommentArea(true)
      setDisabled(true);
      dispatch(
        PostComment(parser, (response) => {
          if (response != 'error') {
            if (response.status_code == 200) {
              setMainComment('');
              commentPaginationStart = 0;

              getComments();
              setDisabled(false);
            }
          }
        })
      );
    } else {
      toast.error('Please write your comment');
      setDisabled(false);
    }
  };

  const submitreply = (index, commentId) => {
    if (replyInput != '') {
      trackActivityEvent(CLICK_SUBMIT_REPLY, onReplyComment(page, replyInput));
      let Replyparser = {
        type_id: id,
        type: type,
        primary_comment_id: commentId,
        comment: replyInput
      };
      console.log(Replyparser);
      dispatch(
        PostComment(Replyparser, (response) => {
          if (response != 'error') {
            if (response.status_code == 200) {
              setReplyInput('');
              GetReplies(index, commentId);
              replyPaginationStart = 0;
            }
            showNewComment = false;
          }
        })
      );
    }
  };

  const GetReplies = (index, commentId) => {
    setReplyComments([]);
    setLoader(true);
    setReplySelectedIndex(index);
    replyPaginationStart = 0;
    setShowReplyArea(true);
    // if (replySelectedIndex == index) {
    //   setShowReplyArea(!showReplyArea);
    // } else {
    //   setShowReplyArea(true);
    // }

    dispatch(
      GetReplyComments(commentId, replyPaginationStart, 5, (res) => {
        if (res != 'error') {
          console.log(res.data);
          setReplyComments(res.data);
          setViewMoreReplyBtn(true);
          setLoader(false);
        }
      })
    );
  };

  const getMoreComments = () => {
    trackActivityEvent(EVENT, trackEvent('CLICK_VIEW_MORE_COMMENTS'));
    commentPaginationStart = commentPaginationStart + 3;
    setLoader(true);
    getComments();
  };

  const getMoreReplies = (commentId) => {
    replyPaginationStart = replyPaginationStart + 5;
    trackActivityEvent(EVENT, trackEvent('CLICK_VIEW_MORE_REPLIES'));
    dispatch(
      GetReplyComments(commentId, replyPaginationStart, 5, (res) => {
        if (res != 'error') {
          if (res.data.length > 0 && res.data[0] != null) {
            setReplyComments((prevArray) => [...prevArray, ...res.data]);
          } else {
            setViewMoreReplyBtn(false);
            setReplyComments((prevArray) => [...prevArray]);
          }

          setLoader(false);
        }
      })
    );
  };
  const handleLikingComment = (commentsList, type_id) => {
    let index = commentsList?.findIndex((_c) => _c.commentId == type_id);

    if (commentsList[index].liked) {
      commentsList[index].rating = parseInt(commentsList[index]?.rating ?? 0) - 1;
    } else {
      commentsList[index].rating = parseInt(commentsList[index]?.rating ?? 0) + 1;
    }
    commentsList[index].liked = !commentsList[index].liked;
    refresh();
    log('reply comments', commentsList);
  };
  const onLikePress = (type_id, type, isReply) => {
    handleLikingComment(isReply ? ReplyComments : comments, type_id);
    dispatch(
      likePress({ type_id, type }, (res) => {
        if (res?.data) {
          console.log('====>>', res?.data);
        }
      })
    );
  };

  const onCommentBoxFocus = () => {
    // document.removeEventListener('keydown', () => {}, false);
    dispatch(toggleCommentFocus(true));
  };
  const onCommentBoxBlur = () => {
    // document.addEventListener('keydown', () => {}, false);
    dispatch(toggleCommentFocus(false));
  };
  return (
    <div className="w-100 comments">
      {title && (
        <h4 className="fs-3 text-black commentsTtl mb-20 border-bottom border-light pb-2 position-relative">
          {title}
        </h4>
      )}
      <div className="clearfix"></div>
      <div
        id="commentFrom"
        className="commentFrom position-relative d-flex justify-content-between mb-0 mb-md-5 align-items-center"
      >
        <div
          className="rounded-circle commentBy position-relative overflow-hidden d-flex justify-content-center align-items-center flex-shrink-0"
          style={{ backgroundColor: '#fff' }}
        >
          <LazyImage
            src={profileImage}
            alt="profile image"
            className="object-fit-cover w-100 h-100 float-start"
            fallback_image={
              'https://firebasestorage.googleapis.com/v0/b/clirnetapp.appspot.com/o/doctor%2F0E57DB94-9662-11F6-3541-148D6F42BDC8%2F0E57DB94-9662-11F6-3541-148D6F42BDC8167242955049480.png?alt=media&token=1754cd39-f142-4ad9-aca8-8cc102dfe88f'
            }
          />
          {/* <h6 className="fw-semibold text-white fs-1 text-uppercase">A</h6> */}
        </div>
        <div className="commentFromIn flex-1 ps-3 ps-md-4 position-relative">
          <Form className="w-100 commentFromField position-relative d-flex justify-content-between align-items-center">
            <Form.Floating className="position-relative me-3 me-md-4">
              <Form.Control
                className={`fs-4 fw-semibold p-0 bg-transparent gtm_cl_comment_input`}
                id="CommentBoxInput"
                placeholder="Write a comment here"
                value={mainComment}
                onFocus={onCommentBoxFocus}
                onBlur={onCommentBoxBlur}
                onChange={(e) => setMainComment(e.target.value)}
              />
              <label
                htmlFor="floatingInputCustom fw-semibold"
                className="w-100 h-100 p-0 m-0 overflow-visible"
              >
                <span className="position-absolute start-0">Write a comment here</span>
              </label>
            </Form.Floating>
            <Button
              type="submit"
              disabled={disabled}
              onClick={(e) => {
                e.preventDefault();
                showNewComment = true;
                submitComment(id, type);
              }}
              className={`rippleEffect rounded btn btn-primary px-3 py-3 px-md-4 fs-4 gtm_cl_comment_submit`}
              aria-label="Submit"
            >
              Submit
            </Button>
          </Form>
        </div>
      </div>

      {comments && comments[0] != null ? (
        <div className="w-100 commentArea">
          {comments.map((commentData, index) => {
            let profileImage = commentData?.images ? commentData.images : null;
            return (
              <ul
                key={index + 1}
                className={`w-100 commentRow mb-4 ps-0 ${
                  (replyFieldShow && replyFieldIndex == index) ||
                  (showReplyArea && replySelectedIndex == index)
                    ? 'commentReplyShow'
                    : ''
                }`}
              >
                {/* comment row for loop */}

                {commentData != null && (
                  <li className="w-100 commentRowIn position-relative d-inline-flex">
                    {profileImage && (
                      <div
                        className="rounded-circle commentv1Pic position-relative overflow-hidden "
                        style={{ backgroundColor: '#fff' }}
                      >
                        <LazyImage
                          src={profileImage}
                          alt="profile image"
                          className="object-fit-cover w-100 h-100 float-start"
                          fallback_image={
                            'https://firebasestorage.googleapis.com/v0/b/clirnetapp.appspot.com/o/doctor%2F0E57DB94-9662-11F6-3541-148D6F42BDC8%2F0E57DB94-9662-11F6-3541-148D6F42BDC8167242955049480.png?alt=media&token=1754cd39-f142-4ad9-aca8-8cc102dfe88f'
                          }
                        />
                      </div>
                    )}
                    {!profileImage && (
                      <div
                        className="rounded-circle commentv1Pic position-relative overflow-hidden d-flex justify-content-center align-items-center"
                        style={{ backgroundColor: '#34caf5' }}
                      >
                        <h6 className="fw-semibold text-white fs-1 text-uppercase">
                          {commentData?.first_name ? commentData?.first_name.slice(0, 1) : 'Dr'}{' '}
                        </h6>
                        {/* <LazyImage
                          src={profileImage}
                          alt="profile image"
                          className="object-fit-cover w-100 h-100 float-start"
                          fallback_image={
                            'https://firebasestorage.googleapis.com/v0/b/clirnetapp.appspot.com/o/doctor%2F0E57DB94-9662-11F6-3541-148D6F42BDC8%2F0E57DB94-9662-11F6-3541-148D6F42BDC8167242955049480.png?alt=media&token=1754cd39-f142-4ad9-aca8-8cc102dfe88f'
                          }
                        /> */}
                      </div>
                    )}

                    <div className="commentContent ps-3 ps-md-4">
                      <div className="fs-4 commentContentMain bg-light d-inline-block py-3 px-4 position-relative">
                        <h4 className="fs-4 fw-medium text-black commentv1PostBy">
                          {commentData?.name}
                        </h4>
                        <p>{commentData?.body}</p>
                      </div>

                      <div className="d-flex align-items-center commentContentReplyTrigr mt-2">
                        <a
                          href="javascript:void(0)"
                          onClick={() => onLikePress(commentData?.commentId, 'comment', false)}
                          className={`cursorPointer d-inline-flex align-items-center me-4 text-primary ${
                            commentData?.liked ? 'active' : ''
                          } gtm_cl_comment_commentLike`}
                        >
                          <span className="icon position-relative d-inline-block me-1 align-middle">
                            {commentData?.liked ? (
                              <>
                                <AiFillLike
                                  customClass={`fillIcon fs-3 text-primary position-absolute start-0 top-50 translate-middle-y gtm_cl_comment_commentLike`}
                                />
                              </>
                            ) : (
                              <>
                                <AiOutlineLike
                                  customClass={`fs-3 lineIcon position-absolute start-0 top-50 translate-middle-y gtm_cl_comment_commentLike`}
                                />
                              </>
                            )}
                          </span>
                          {commentData?.rating
                            ? commentData?.rating == 0
                              ? null
                              : commentData?.rating
                            : null}
                        </a>
                        <a
                          href="javascript:void(0)"
                          className={`text-primary rippleEffect me-4 gtm_cl_comment_reply`}
                          onClick={() => {
                            setReplyFieldShow(!replyFieldShow);
                            setreplyFieldIndex(index);
                            setReplyInput('');
                          }}
                        >
                          {replyFieldShow && replyFieldIndex == index ? (
                            <span className={`text-danger gtm_cl_comment_cancel`}> </span>
                          ) : (
                            'Reply'
                          )}
                        </a>

                        {showReplyArea && replySelectedIndex == index ? (
                          <a
                            href="javascript:void(0)"
                            className={`text-primary rippleEffect me-4 gtm_cl_comment_ShowHideRelies`}
                            onClick={() => {
                              setShowReplyArea(!showReplyArea);
                            }}
                          >
                            Hide Replies
                            {/* <span className="fs-6 text-black">(02)</span>{" "} */}
                          </a>
                        ) : (
                          comments && (
                            <a
                              href="javascript:void(0)"
                              className={`text-primary rippleEffect me-4 medwiki_detail_comment_reply gtm_cl_comment_ShowHideRelies`}
                              onClick={() => GetReplies(index, commentData.commentId)}
                            >
                              Show Replies
                            </a>
                          )
                        )}
                      </div>

                      {replyFieldShow && replyFieldIndex == index ? (
                        <div className="commentFrom mb-2 mt-4">
                          <div className="commentFromIn ps-4">
                            <Form className="w-100 commentFromField position-relative d-flex justify-content-between align-items-center">
                              <Form.Floating className="position-relative me-3 me-md-4">
                                <Form.Control
                                  className={`fs-4 fw-semibold p-0 bg-transparent gtm_cl_comment_input`}
                                  id="floatingInputCustom"
                                  onChange={(e) => {
                                    // setRender(true);
                                    console.log('comment reply', e.target.value);
                                    setReplyInput(e.target.value);
                                  }}
                                  onFocus={onCommentBoxFocus}
                                  onBlur={onCommentBoxBlur}
                                  value={replyInput}
                                  placeholder="Write a comment here"
                                />
                                <label
                                  htmlFor="floatingInputCustom fw-semibold"
                                  className="w-100 h-100 p-0 m-0 overflow-visible"
                                >
                                  <span className="position-absolute start-0">
                                    Write a Reply here
                                  </span>
                                </label>
                              </Form.Floating>
                              <Button
                                type="submit"
                                className={`rippleEffect rounded btn btn-primary px-3 py-2 px-md-4 fs-4 fs-5 gtm_cl_comment_reply`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  showNewComment = true;
                                  submitreply(index, commentData.commentId);
                                }}
                                aria-label="Reply"
                              >
                                Reply
                              </Button>
                            </Form>
                          </div>
                        </div>
                      ) : null}

                      <div className="d-flex align-items-center commentContentReplyTrigr mt-2">
                        <a
                          href="javascript:void(0)"
                          className={`text-primary rippleEffect me-4 gtm_cl_comment_reply`}
                          onClick={() => {
                            setReplyFieldShow(!replyFieldShow);
                            setreplyFieldIndex(index);
                          }}
                        >
                          {replyFieldShow && replyFieldIndex == index ? (
                            <span className={`text-danger gtm_cl_comment_cancel`}>Cancel</span>
                          ) : (
                            ''
                          )}
                        </a>
                      </div>

                      {showReplyArea && replySelectedIndex == index ? (
                        loader == false ? (
                          ReplyComments[0] != null ? (
                            <>
                              {ReplyComments.map((replyData, index) => {
                                let profileImage = replyData?.images ?? null;
                                return (
                                  <div className="w-100 commentReplyArea mt-3" key={index + 1}>
                                    <ul className="w-100 commentRow mb-2">
                                      {' '}
                                      {/* comment row for loop */}
                                      <li className="w-100 commentRowIn position-relative d-inline-flex">
                                        <div
                                          className="rounded-circle commentv1Pic position-relative overflow-hidden d-flex justify-content-center align-items-center  me-3"
                                          style={{ backgroundColor: '#d06a2f' }}
                                        >
                                          {/* <h6 className="fw-semibold text-white fs-3 text-uppercase">
                                            {replyData?.first_name
                                              ? replyData?.first_name.slice(0, 1)
                                              : 'Dr'}
                                          </h6> */}

                                          <LazyImage
                                            src={profileImage}
                                            alt="profile image"
                                            className="object_fit_cover w-100 h-100"
                                            fallback_image={
                                              'https://firebasestorage.googleapis.com/v0/b/clirnetapp.appspot.com/o/doctor%2F0E57DB94-9662-11F6-3541-148D6F42BDC8%2F0E57DB94-9662-11F6-3541-148D6F42BDC8167242955049480.png?alt=media&token=1754cd39-f142-4ad9-aca8-8cc102dfe88f'
                                            }
                                          />
                                        </div>
                                        {/* {profileImage ? (
                                          <div
                                            className="rounded-circle commentv1Pic overflow-hidden"
                                            style={{ backgroundColor: '#fff' }}
                                          >
                                            <LazyImage
                                              src={profileImage}
                                              alt="profile image"
                                              className="object_fit_cover w-100 h-100"
                                              fallback_image={
                                                'https://firebasestorage.googleapis.com/v0/b/clirnetapp.appspot.com/o/doctor%2F0E57DB94-9662-11F6-3541-148D6F42BDC8%2F0E57DB94-9662-11F6-3541-148D6F42BDC8167242955049480.png?alt=media&token=1754cd39-f142-4ad9-aca8-8cc102dfe88f'
                                              }
                                            />
                                          </div>
                                        ) : (
                                          <div
                                            className="rounded-circle commentv1Pic"
                                            style={{ backgroundColor: '#d06a2f' }}
                                          >
                                            <h6 className="fw-semibold text-white fs-1 text-uppercase">
                                              {commentData?.first_name
                                                ? commentData?.first_name.slice(0, 1)
                                                : 'Dr'}
                                            </h6>
                                          </div>
                                        )} */}
                                        <div className="commentContent">
                                          <div className="fs-4 commentContentMain">
                                            <h4 className="fs-4 fw-medium text-black commentv1PostBy">
                                              {replyData?.name}
                                            </h4>
                                            <p>{replyData?.body}</p>
                                          </div>
                                          <div className="d-flex align-items-center commentContentReplyTrigr mt-2">
                                            <a
                                              href="javascript:void(0)"
                                              onClick={() =>
                                                onLikePress(replyData?.commentId, 'comment', true)
                                              }
                                              className={`cursorPointer d-inline-flex align-items-center d-inline-block me-4 text-primary ${
                                                replyData?.liked ? 'active' : ''
                                              } gtm_cl_comment_commentLike`}
                                            >
                                              <span className="icon position-relative d-inline-block me-1 align-middle">
                                                {replyData?.liked ? (
                                                  <>
                                                    <AiFillLike
                                                      customClass={`fillIcon fs-3 text-primary position-absolute start-0 top-50 translate-middle-y gtm_cl_comment_commentLike`}
                                                    />
                                                  </>
                                                ) : (
                                                  <>
                                                    <AiOutlineLike
                                                      customClass={`fs-3 lineIcon position-absolute start-0 top-50 translate-middle-y gtm_cl_comment_commentLike`}
                                                    />
                                                  </>
                                                )}
                                              </span>
                                              {replyData?.rating
                                                ? replyData?.rating == 0
                                                  ? null
                                                  : replyData?.rating
                                                : null}
                                            </a>
                                          </div>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                );
                              })}
                              {viewMoreReplybtn ? (
                                ReplyComments.length <= 5 ? (
                                  <a onClick={() => getMoreReplies(commentData.commentId)}>
                                    <div
                                      className={`cursorPointer text-primary gtm_cl_comment_viewMore`}
                                    >
                                      View More
                                    </div>
                                  </a>
                                ) : (
                                  <></>
                                )
                              ) : (
                                <div>No More Replies</div>
                              )}
                            </>
                          ) : (
                            <div>No Replies</div>
                          )
                        ) : (
                          <div>
                            <Spinner animation="border" size="sm" />
                          </div>
                        )
                      ) : null}
                    </div>
                  </li>
                )}
              </ul>
            );
          })}
        </div>
      ) : null}

      {comments.length > 2 && showCommentArea ? (
        <div className="w-100 text-center viewMoreComments mt-4 position-relative">
          <a
            href="javascript:void(0)"
            className={`fs-4 fw-medium viewMoreComments_a rippleEffect d-inline-block align-middle position-relative z-3 bg-body px-3 gtm_cl_comment_veiwMore`}
            onClick={getMoreComments}
          >
            {loader == false ? (
              'View more comments'
            ) : loader ? (
              <Spinner animation="border" size="sm" />
            ) : null}
          </a>
        </div>
      ) : null}
    </div>
  );
};

export default Comments;
